import React, { useState } from 'react';
import images from '../images';
import LogoBlock from '../components/LogoBlock';
import {useNavigate} from "react-router-dom";
import PasswordResetForm from "../components/Forms/PasswordResetForm";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Пожалуйста, введите email');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Заглушка для функции восстановления пароля
      console.log('Отправка письма на', email);
      // Имитация задержки
      await new Promise(resolve => setTimeout(resolve, 1000));
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-content">
          <LogoBlock />
          <PasswordResetForm
            email={email}
            setEmail={setEmail}
            loading={loading}
            error={error}
            handleSubmit={handleSubmit}
          />
          <div className="login-footer">
            <p>Ещё не заключили договор? <a href="https://partner-leeds.ru/" className="login-link">Свяжитесь с нами, оставив заявку на сайте</a></p>
          </div>
        </div>
        </div>
        <div
            className="login-right"
          style={{backgroundImage: `url(${images.loginBackground})` }}
      ></div>
    </div>
  );
};

export default ForgotPassword;